export default __webpack_public_path__ + "static/media/launchIcon.be9225d5.svg";